import React, { FC } from 'react';
import { Load } from '../../../../types';
import { DisplayLoadStops } from './display-load-stops';
import { EditableLoadStops } from './editable-load-stops';
import { StopsHeader } from './headers/stops-header';

interface LoadTableStopsProps {
    // if load is provided we are in 'not-editable' mode
    // in edit mode we are using useDraftLoadContext
    load?: Load;
    showInlineSaveButton?: boolean;
}

export const LoadTableStops: FC<LoadTableStopsProps> = (props) => {
    const { load, showInlineSaveButton = false } = props;

    return (
        <div className='lt-stops-container'>
            <StopsHeader isEditable={load ? false : true} />
            {load ? (
                <DisplayLoadStops load={load} />
            ) : (
                <EditableLoadStops showInlineSaveButton={showInlineSaveButton} />
            )}
        </div>
    );
};
